<template>
  <v-container fluid class="px-2 pb-0">
    <v-text-field
      v-model="search"
      background-color="colorSearchSettings"
      clearable
      :append-icon="mdiMagnify"
      :label="$t('label.search')"
      hide-details
      class="pt-0"
    />
    <div style="min-height: 1px"></div>
    <v-data-table
      :items="tableData"
      :headers="headers"
      :search="search"
      item-key="id"
      :height="$store.state.windowSize.y - 160"
      fixed-header
      must-sort
      :items-per-page="50"
      :footer-props="{ itemsPerPageOptions: [50, 100, 150, 200] }"
      dense
      :loading="loaderStatus"
      class="tableSelectCursor"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ `${item.name} ${item.surname}` }}</td>
          <td>{{ `${item.employeeName} ${item.employeeSurname}` }}</td>
          <td>{{ `${item.plannerName} ${item.plannerSurname}` }}</td>
          <td>{{ `${item.approverName} ${item.approverSurname}` }}</td>
          <td>{{ formatDateTZ(item.timearrive, item.timezone, $store.state.auth.df.dateYearTime) }}</td>
          <td>{{ formatDateTZ(item.timedeparture, item.timezone, $store.state.auth.df.dateYearTime) }}</td>
          <td>
            <v-tooltip v-if="item.approvalstatus == 0" bottom :open-delay="500">
              <template v-slot:activator="{ on }">
                <v-icon color="orange" v-on="on">{{ mdiHelp }}</v-icon>
              </template>
              <span>{{ $t('label.approvalWaiting') }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.approvalstatus == 1" bottom :open-delay="500">
              <template v-slot:activator="{ on }">
                <v-icon color="green" v-on="on">{{ mdiCheckBold }}</v-icon>
              </template>
              <span>{{ $t('label.approved') }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.approvalstatus == 2" bottom :open-delay="500">
              <template v-slot:activator="{ on }">
                <v-icon color="red" v-on="on">{{ mdiCloseThick }}</v-icon>
              </template>
              <span>{{ $t('label.declined') }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.approvalstatus == 10" bottom :open-delay="500">
              <template v-slot:activator="{ on }">
                <v-icon color="blue" v-on="on">{{ mdiAccountArrowLeft }}</v-icon>
              </template>
              <span>{{ $t('label.inObject') }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.approvalstatus == 11" bottom :open-delay="500">
              <template v-slot:activator="{ on }">
                <v-icon color="grey darken-2" v-on="on">{{ mdiAccountArrowRight }}</v-icon>
              </template>
              <span>{{ $t('label.visitClosed') }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import {
  mdiHelp,
  mdiCheckBold,
  mdiCloseThick,
  mdiChevronLeft,
  mdiChevronRight,
  mdiClose,
  mdiAccountArrowLeft,
  mdiAccountArrowRight,
  mdiMagnify,
} from '@mdi/js';

export default Vue.extend({
  name: 'ArchiveByEmployee',
  data: () => ({
    tableData: [] as any[],
    search: '',
    loaderStatus: false,
    mdiHelp: mdiHelp,
    mdiCheckBold: mdiCheckBold,
    mdiCloseThick: mdiCloseThick,
    mdiChevronLeft: mdiChevronLeft,
    mdiChevronRight: mdiChevronRight,
    mdiClose: mdiClose,
    mdiAccountArrowLeft: mdiAccountArrowLeft,
    mdiAccountArrowRight: mdiAccountArrowRight,
    mdiMagnify: mdiMagnify,
  }),
  computed: {
    headers: function () {
      return [
        { text: this.$i18n.tc('label.visitor'), value: 'name' },
        { text: this.$i18n.tc('label.visiting'), value: 'employeeName' },
        { text: this.$i18n.tc('label.plannedBy'), value: 'plannerName' },
        { text: this.$i18n.tc('label.approvedBy'), value: 'approverName' },
        { text: this.$i18n.tc('label.arrival'), value: 'timearrive' },
        { text: this.$i18n.tc('label.departure'), value: 'timedeparture' },
        { text: this.$i18n.tc('label.state'), sortable: false, width: '48px' },
      ];
    },
  },
  mounted() {
    this.dataLoad();
  },
  methods: {
    dataLoad() {
      this.loaderStatus = true;
      axios
        .get(`/api/v1/plannedvisits/employee/archive`)
        .then((response) => {
          this.tableData = response.data;
          this.loaderStatus = false;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
          this.loaderStatus = false;
        });
    },
    formatDateTZ(date: string, timeZone: string, format: string) {
      return this.$moment(date).tz(timeZone).format(format);
    },
  },
});
</script>
